const DOM = Object.freeze({
  formStatusSelector: '[data-f-form-status]',
});

export const epiForms = () => {
  if (typeof $$epiforms !== 'undefined') {
    const $formStatusMessage = $$epiforms('.EPiServerForms')[0].querySelector(
      DOM.formStatusSelector,
    );

    if ($formStatusMessage) {
      $$epiforms('.EPiServerForms').on('formsSubmitted', function() {
        $formStatusMessage.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center',
        });
      });
    }
  }
};
